import React, { Component } from 'react';
import styles from './styles.scss';
import qs from "query-string";
import WJSON from '../../helpers/json';
import UserInfo from '../../helpers/userinfo';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WModal from '../../components/WModal/WModal';
import moment from 'moment';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WWebView from '../../helpers/wwebview';
class UserProfile extends Component 
{
  constructor(props){
    super(props);

    let currentYear = parseInt(moment().format('YYYY'), 10)
    let year = currentYear
    var years = []

    while(year > (currentYear - 100))
    {
      years.push(year)
      year -= 1
    }
    
    this.state = {
      show_spinner: true,
      years:years,
      mobile_verification: false, //用來判斷這個頁面是否修改
      can_update: false, //用來判斷資料是否有更動
      form:{
        name:'',
        mobile:'',
        mail:'',
        birthday_year:'',
        birthday_month:'',
        birthday_day:'',
      }
    };
  }

  componentDidMount(){
    this.setState({ show_spinner: true });
    // Mount上去後拉最新的資料
    console.log('componentDidMount')

    this.pullUserInfo()
  }
  pullUserInfo()
  {
    UserInfo.pullData((code=100, userinfo={}, reason='發生錯誤，請洽社區物管') => {
      this.setState({ show_spinner: false });
      var {form ={}} = this.state

      var birthday_year  = ''
      var birthday_month = ''
      var birthday_day   = ''

      let moment_birthday = moment(userinfo.birthday,'YYYYMMDD');

      console.log(moment_birthday.isValid(), moment_birthday);

      if (moment_birthday.isValid())
      {
        //let birthday   = userinfo.birthday
        
        birthday_year  = moment_birthday.format('YYYY')// birthday.substring(0, 4)

        birthday_month = moment_birthday.format('MM')// birthday.substring(4, 6)
        
        birthday_day   = moment_birthday.format('DD')// birthday.substring(6)
        console.log(userinfo.birthday, birthday_year, birthday_month, birthday_day)
      }
      
      form = Object.assign(form, {
          name           : userinfo.name || '',
          mobile         : userinfo.mobile || '',
          mail           : userinfo.mail|| '',
          birthday_year  : birthday_year,
          birthday_month : birthday_month,
          birthday_day   : birthday_day,
        });

      // 2018.12.02 發送咖啡券活動期間，都可以UPDATE
      this.setState({ 
        can_update: true, //userinfo.mobile_verification == 0,
        mobile_verification: userinfo.mobile_verification == 1,
        form: form
      });

    })
  }
  handleFormChange(evt) { 
    evt.preventDefault();
    var form = this.state.form
    form[evt.target.name] = evt.target.value
    
    var data = {
      name     : form.name,
      mobile   : form.mobile,
      mail     : form.mail,
      birthday : moment(`${form.birthday_year}-${form.birthday_month}-${form.birthday_day}`,'YYYY-M-DD').format('YYYYMMDD'),
    }

    var isModified = (
         UserInfo.name     != form.name
      || UserInfo.mobile   != form.mobile
      || UserInfo.mail     != form.mail
      || UserInfo.birthday != moment(`${form.birthday_year}-${form.birthday_month}-${form.birthday_day}`,'YYYY-M-DD').format('YYYYMMDD')
    ) ? true : false;

    
    var mobile_verification = UserInfo.mobile_verification == 1 && UserInfo.mobile == form.mobile
    
    // 2018.12.02 發送咖啡券活動期間，都可以UPDATE
    this.setState({ 
      can_update: true, //(isModified === true || mobile_verification === false),
      mobile_verification: mobile_verification,
      form: form
    }); 
  }

  updateInfo() {

    const {form} = this.state
    //先檢查生日
    let birthday_year  = this.refs.birthday_year.value
    let birthday_month = this.refs.birthday_month.value
    let birthday_day   = this.refs.birthday_day.value
    let moment_birthday = moment(`${birthday_year}-${birthday_month}-${birthday_day}`,'YYYY-M-DD');
    
    if (   birthday_year  == 'unselected'
        || birthday_month == 'unselected'
        || birthday_day   == 'unselected'
        || !moment_birthday.isValid())
    {
      return  WModal.show('請輸入生日資料');
    }
    
    var data = {
      name     : form.name,
      mobile   : form.mobile,
      mail     : form.mail,
      birthday : moment_birthday.format('YYYYMMDD'),
    }

    this.setState({ show_spinner: true });
    http.post(CONFIG.API_HOST + 'api/v1.3/user/profile', 
      data
      , 
      (state, res) => {

        this.setState({ show_spinner: false });

        const {code=100, reason='發生錯誤，請洽社區物管', data={} } = res;

        if (state === false) { return  WModal.show('發生錯誤，請洽社區物管'); }

        if (code !== 200)    { 
          if (code == 313)
          {
            WModal.show('資料修改完成',null, {callback:(title) => {
              WModal.show(reason);
            }});
            return;
          }
          return WModal.show(reason); 
        }

        const { user:userinfo = {} } = data;
        var {form ={}} = this.state

        var birthday_year  = '1970'
        var birthday_month = '12'
        var birthday_day   = '12'

        if (userinfo.birthday)
        {
          let birthday   = userinfo.birthday

          birthday_year  = birthday.substring(0, 4)

          birthday_month = birthday.substring(4, 6)
          
          birthday_day   = birthday.substring(6)
          
        }
        
        form = Object.assign(form, {
            name           : userinfo.name || '',
            mobile         : userinfo.mobile || '',
            mail           : userinfo.mail|| '',
            birthday_year  : birthday_year,
            birthday_month : birthday_month,
            birthday_day   : birthday_day,
          });

        this.setState({ 
          mobile_verification: userinfo.mobile_verification == 1,
          form: form
        });

        const { redirect_url = null } = data;

        if (redirect_url)
        {
          return window.location.href = redirect_url
        }
        
        WModal.show('資料修改完成', "", {callback:(title) => {
          WWebView.goBack()
        }})
    })
  }

  render()
  {

    let months = []

    for (let i = 1; i <= 12; i++) { months.push(i) }
    
    let m = moment(`${this.state.form.birthday_year}-${this.state.form.birthday_month}-01`,"YYYY-M-DD")
    
    let daysInMonth = []
    
    for (let i = 1; i <= m.daysInMonth(); i++) { daysInMonth.push(i) }

    return (
      <div className={styles.page_container}>
        <div className={[/*styles.mobile,*/ 'container'].join(' ')}>
          <h1>住戶資料修改</h1>
          <p>*以下皆為必填</p>
          <form onSubmit={(e) => {e.preventDefault();}} >
            <div className="form-group">
              <label>姓名</label>
              <input type="text" 
                     className="form-control"
                     name="name" 
                     placeholder=''
                     value={this.state.form.name}
                     readOnly
                     onChange={(evt) => this.handleFormChange(evt)} />
              {
                /*
                this.state.form.name.length == 0 && 
                <label className="red">*請填寫以上欄位資料</label>
                */
              }
            </div>
            <div className="form-group">
              <label>*行動電話</label>
              <input type="text" 
                     className="form-control"
                     name="mobile" 
                     placeholder='如：0912345678'
                     value={this.state.form.mobile}
                     onChange={(evt) => this.handleFormChange(evt)} />
              {
                this.state.form.mobile.length == 0 && 
                <label className="red">*請填寫以上欄位資料</label>
              }
              {
                this.state.mobile_verification ?
                <label>✔ 已驗證</label>
                :
                <label className="red">✖ 您尚未完成電話驗證，按下「儲存」重新進行驗證</label>
              }
            </div>
            <div className="form-group">
              <label>*Email</label>
              <input type="email" 
                     className="form-control"
                     name="mail" 
                     placeholder=''
                     value={this.state.form.mail}
                     onChange={(evt) => this.handleFormChange(evt)} />
              {
                this.state.form.mail.length == 0 && 
                <label className="red">*請填寫以上欄位資料</label>
              }
            </div>

            <div className="form-group">
              <label>*生日</label>
              <div>
                <select className="form-control"
                        name="birthday_year" 
                        ref="birthday_year" 
                        onChange={(evt) => this.handleFormChange(evt)}
                  >
                  <option disabled selected value="unselected">年份</option>
                  {
                    this.state.years.map((y, idx) => 
                      <option selected={y == this.state.form.birthday_year}>{y}</option>
                    )
                  }
                </select>
                <select className="form-control"
                        name="birthday_month" 
                        ref="birthday_month" 
                        onChange={(evt) => this.handleFormChange(evt)}
                  >
                  <option disabled selected value="unselected">月</option>

                  { months.map((m, idx) => 
                      <option selected={m == parseInt(this.state.form.birthday_month, 10)}>{m}</option>
                    )
                  }
                  
                </select>

                <select className="form-control"
                        name="birthday_day" 
                        ref="birthday_day" 
                        onChange={(evt) => this.handleFormChange(evt)}
                  >
                  <option disabled selected value="unselected">日</option>

                  { daysInMonth.map((m, idx) => 
                      <option selected={m == parseInt(this.state.form.birthday_day, 10)}>{m}</option>
                    )
                  }
                  
                </select>
              </div>
              {
                (this.state.form.birthday_year.length == '' || this.state.form.birthday_month.length == '' || this.state.form.birthday_day.length == '') && 
                <label className="red">*請填寫以上欄位資料</label>
              }
            </div>

            { UserInfo.userid && UserInfo.userid.match(/001$/) && 
              <div className="form-group">
                <label className="red">※以上資料限所有權人使用，如為承租者請洽物管新增專用帳號</label>
              </div>
            }

            {/*
              <div>
                <a type="button" className="btn btn-default" href="https://testbox.shoppalz.com/fg/webview_event.html" >
                  測試上一頁與回首頁
                </a>
              </div>
            */}

            <div>
              
              <button type="button" 
                      className={this.state.can_update === false ? 'btn btn-default' : 'btn-primary'} 
                      disabled={ this.state.can_update === false ? true : null }
                      onClick={() => {
                        console.log(this.state.can_update)
                        if (this.state.can_update === false) 
                        {
                          return;
                        }
                        this.updateInfo() 
                      }} >
                儲存
              </button>
              <button type="button" className="btn btn-default" onClick={ e => { WWebView.goBack() }} >
                取消
              </button>
            </div>
            
          </form>
          { this.state.show_spinner && <WMask><WSpinner/></WMask> }
        </div>
        { /*
        <div className={[styles.desktop, 'container'].join(' ')}>
          <h1>遠雄社區雲帳號註冊</h1>
          <p>*以下皆為必填</p>
          <form>
            <div className="form-group">
              <label>身份</label>
              <select className="form-control">
                <option disabled selected>請選擇</option>
                <option>屋主(所有權人)</option>
                <option>屋主親友</option>
                <option>租客</option>
              </select>
            </div>
            <div className="form-group">
              <label>社區</label>
              <select className="form-control">
                <option disabled selected>請選擇</option>
                <option>Ａ社區</option>
                <option>Ｂ社區</option>
                <option>Ｃ社區</option>
              </select>
            </div>
            <div className="form-group">
              <label>社區</label>
              <div>
                <select className="form-control">
                  <option disabled selected>棟</option>
                  <option>Ａ社區</option>
                  <option>Ｂ社區</option>
                  <option>Ｃ社區</option>
                </select>
                <select className="form-control">
                  <option disabled selected>樓</option>
                  <option>Ａ社區</option>
                  <option>Ｂ社區</option>
                  <option>Ｃ社區</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label>身分證字號</label>
              <input className="form-control"/>
            </div>
            <div className="form-group">
              <label>行動電話</label>
              <input className="form-control" placeholder='如：0912345678'/>
            </div>
            <div className="form-group">
              <label>Email</label>
              <input className="form-control" type='email'/>
            </div>
            <div>
              <h4>電子報訂閱</h4>
              <div className="form-group">
                <div className={[styles.checkbox, "checkbox"].join(' ')}>
                  <label>
                    <input type="checkbox"/>
                    <span className={styles.checkmark}/>
                    遠雄房產建案資訊報
                  </label>
                </div>
                <div className={[styles.checkbox, "checkbox"].join(' ')}>
                  <label>
                    <input type="checkbox"/>
                    <span className={styles.checkmark}/>
                    遠雄社區活動報(DIY作、大型園遊會、理財講座)
                  </label>
                </div>
              </div>
              <hr/>
              <h4>同意條款</h4>
              <div className="form-group">
                <div className={[styles.checkbox, "checkbox"].join(' ')}>
                  <label>
                    <input type="checkbox"/>
                    <span className={styles.checkmark}/>
                    我已同意成為遠雄之友
                  </label>
                </div>
                <div className={[styles.checkbox, "checkbox"].join(' ')}>
                  <label>
                    <input type="checkbox"/>
                    <span className={styles.checkmark}/>
                    我已閱讀並同意遠雄集團隱私權政策相關規定
                  </label>
                </div>
              </div>
            </div>
            <div>
              <button type="submit" className="btn btn-primary">新增</button>
              <button type="submit" className="btn btn-default">取消</button>
            </div>
          </form>
        </div>
        */ }
      </div>
    );
  }
}

export default UserProfile;


// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.js